import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineLpView のスタイル
 */
export const hotlineLpViewStyle = tv({
    slots: {
        base: ['relative z-10', 'bg-[#FFFFFF]'],
        contents: ['mx-auto overflow-hidden'],
    },
});
